export default "__VITE_ASSET__b701682f__"